import { Text } from '@pancakeswap/uikit'
import styled from 'styled-components'

const CrossText = styled(Text)`
  text-decoration: line-through;
`

export default CrossText
